module.exports = __webpack_public_path__ + "img/delivery.dcf38dce.svg";